import { centsToDollars, parsePrice } from "helpers/price";
import { Column } from "primereact/column";
import {
  SpecialtyList,
  SpecialtyListDictCheckout,
} from "types/Provider/Provider";

import { HorizontalLine, StyledDataTable } from "../styled";

interface IBreakdownRow {
  specialty: SpecialtyList;
  insurance_rate: number;
  insurance_pays: number;
  you_pay: number;
}

interface IBreakdownTable {
  breakdown: IBreakdownRow[];
}

function BreakdownTable({ breakdown }: IBreakdownTable) {
  const totals = {
    insurance_rate:
      breakdown?.reduce((sum, row) => sum + (row.insurance_rate || 0), 0) || 0,
    insurance_pays:
      breakdown?.reduce((sum, row) => sum + (row.insurance_pays || 0), 0) || 0,
    you_pay: breakdown?.reduce((sum, row) => sum + (row.you_pay || 0), 0) || 0,
  };

  return (
    <div className="flex flex-column gap-2 w-full">
      <HorizontalLine className="my-2" />
      <p className="font-semibold text-lg highlighted pl-2">
        Payment Breakdown
      </p>
      <StyledDataTable
        value={breakdown}
        tableStyle={{ minWidth: "20rem", width: "100%" }}
        responsiveLayout="scroll"
      >
        <Column
          field="specialty"
          header="Provider"
          body={(row: IBreakdownRow) =>
            // Fallback to raw value if it's not a known SpecialtyList key
            (SpecialtyListDictCheckout as any)[(row as any).specialty] ||
            (row as any).specialty
          }
          footer="Total"
        />
        <Column
          field="insurance_rate"
          header="Insurance Rate"
          body={(row) => parsePrice(centsToDollars(row.insurance_rate))}
          footer={parsePrice(centsToDollars(totals.insurance_rate))}
        />
        <Column
          field="insurance_pays"
          header="Insurance Pays"
          body={(row) => parsePrice(centsToDollars(row.insurance_pays))}
          footer={parsePrice(centsToDollars(totals.insurance_pays))}
        />
        <Column
          field="you_pay"
          header="You Pay"
          body={(row) => parsePrice(centsToDollars(row.you_pay))}
          footer={parsePrice(centsToDollars(totals.you_pay))}
        />
      </StyledDataTable>
      <HorizontalLine className="my-2" />
    </div>
  );
}

export default BreakdownTable;
